import { OK } from "@/constants/common.constants";
import { PROPERTY_LOOKUP } from "@/constants/property-detail.constant";

export const propertyResponseRequiresEdit = (response) => {
  const dataIsComplete =
    response &&
    response.StatusCode === OK &&
    response.PropertyType > "" &&
    response.NumberOfBedrooms > "" &&
    response.NumberOfBathrooms > "" &&
    response.BuildYear > "" &&
    response.WallConstruction > "" &&
    response.RoofConstruction > "";
  return !dataIsComplete;
};

export const isAllPropertyAddressFilledByUser = (data) => {
  const isFoundProperty = PROPERTY_LOOKUP.filter((interfaceKey) => {
    if (data[interfaceKey] && data[interfaceKey].Source === "User") {
      return true;
    }
    return false;
  });
  return isFoundProperty.length === PROPERTY_LOOKUP.length;
};
